import { Component } from 'shimmer'

import { Renderer } from './Renderer'

import {
  Scene,
  Vector3,
} from 'three'

import { PerspectiveCamera } from '@/webGL/cameras'

console.log(Component)

export class WebGL extends Component {
  constructor (preserveDrawingBuffer = false, transparent = false) {
    super()

    this.resize = this.resize.bind(this)
    this.start = this.start.bind(this)
    this.pause = this.pause.bind(this)

    this.scene = new Scene()

    this.camera = new PerspectiveCamera(50, 1, 1, 1000)
    this.camera.far = 5000
    this.camera.lookAt( new Vector3(0, 0, 0) )

    this.renderer = new Renderer(this.scene, this.camera, preserveDrawingBuffer, transparent)
    this.start()
    this.isActive = true
  }

  start () {
    this.isActive = true
    this.resize()
  }

  pause () {
    this.isActive = false
  }

  onUpdate ({ elapsed }) {
    this.renderer.render()
    this.camera.update()
  }

  resize (args = {}) {
    args.width = args.width !== void 0 ? args.width : window.innerWidth
    args.height = args.height !== void 0 ? args.height : window.innerHeight
    this.renderer.resize(args)
  }

  onDestroy () {
    this.renderer.onDestroy()
    this.destroy()
  }

  set el (el) {
    this.container = el
    this.container.appendChild(this.renderer.canvas)
  }

  get el () {
    return this.container
  }
}

export const webGL = new WebGL()